import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';

const ScribeBulkDeleteModal = ({ isOpen, onClose, onConfirm, consultations, getPatientName }) => {
  if (!isOpen || !consultations || consultations.length === 0) return null;

  return (
    <div className="modal-overlay">
      <div className="delete-modal">
        <div className="modal-header">
          <h2>Confirm Bulk Delete</h2>
          <button className="close-button" onClick={onClose}>
            <FontAwesomeIcon icon={faTimes} />
          </button>
        </div>
        <div className="modal-content">
          <p>Are you sure you want to delete {consultations.length} consultation{consultations.length > 1 ? 's' : ''}?</p>
          <div className="bulk-document-list">
            {consultations.slice(0, 5).map(consultation => (
              <div key={consultation.consultationId} className="bulk-document-item">
                <div className="bulk-document-name">{getPatientName(consultation.nhsId)}</div>
                <div className="bulk-document-assignee">{consultation.timestamp ? new Date(consultation.timestamp).toLocaleDateString() : 'Unknown'}</div>
              </div>
            ))}
            {consultations.length > 5 && (
              <div className="bulk-document-more">
                ... and {consultations.length - 5} more consultation{consultations.length - 5 > 1 ? 's' : ''}
              </div>
            )}
          </div>
          <p style={{ marginTop: '15px', color: '#e74c3c', fontSize: '14px', fontWeight: '600' }}>
            This will permanently delete the recording and all generated content.
          </p>
        </div>
        <div className="modal-actions">
          <button className="cancel-button" onClick={onClose}>Cancel</button>
          <button className="delete-confirm-button" onClick={onConfirm}>Delete All</button>
        </div>
      </div>
    </div>
  );
};

export default ScribeBulkDeleteModal;
